import './element-import'
import wizButton from './wiz-button'
import wizHelloWorld from './wiz-hello-world'
import wizUploadFile from './wiz-upload-file'
import wizTreeSelect from './wiz-tree-select'

const components = { wizButton, wizHelloWorld, wizUploadFile, wizTreeSelect }

const install = (Vue) => {
  if (install.installed) return
  Object.keys(components).forEach((key) => {
    Vue.component(components[key].name, components[key])
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default { install, ...components }
